export default "__VITE_ASSET__B1dL6avV__"